import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-20 w-100" }
const _hoisted_2 = { class: "d-flex gap-20 w-100 flex-column flex-md-row" }
const _hoisted_3 = { class: "d-flex gap-20 w-100 flex-column flex-md-row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("small", { class: "fw-light fs-sm" }, "Minimum 8 characters, One Uppercase, One Lowercase, One Symbol and One Number", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "pdt-10" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-semibold" }, "Security Questions"),
  /*#__PURE__*/_createElementVNode("small", null, "Please select a question and enter an answer, which will be used if you ever forget your password.")
], -1)
const _hoisted_6 = { class: "w-100 d-flex mt-40 gap-20 justify-content-center flex-column" }
const _hoisted_7 = { class: "d-flex gap-20 flex-md-row flex-column" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  width: "24",
  height: "16",
  version: "1.1",
  id: "L9",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  "enable-background": "new 0 0 0 0",
  "xml:space": "preserve"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#8EC986",
  d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
}, [
  /*#__PURE__*/_createElementVNode("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "1s",
    from: "0 50 50",
    to: "360 50 50",
    repeatCount: "indefinite"
  })
], -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_ReCaptcha = _resolveComponent("ReCaptcha")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TextInput, {
          type: "email",
          label: "Email",
          placeholder: "Email",
          max: 100,
          modelValue: _ctx.local.Email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.local.Email) = $event)),
          "is-required": true,
          error: _ctx.errors.Email
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_TextInput, {
          type: "text",
          name: "mixed",
          label: "PIN",
          placeholder: "PIN",
          max: 6,
          modelValue: _ctx.local.PIN,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.local.PIN) = $event)),
          "is-required": true,
          error: _ctx.errors.PIN
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TextInput, {
          type: "text",
          label: "First Name",
          placeholder: "First Name",
          max: 12,
          modelValue: _ctx.local.FirstName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.local.FirstName) = $event)),
          "is-required": true,
          error: _ctx.errors.FirstName
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_TextInput, {
          type: "text",
          label: "Middle Name",
          placeholder: "Middle Name",
          max: 12,
          modelValue: _ctx.local.MiddleName,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.local.MiddleName) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_TextInput, {
          type: "text",
          label: "Last Name",
          placeholder: "Last Name",
          max: 25,
          modelValue: _ctx.local.LastName,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.local.LastName) = $event)),
          "is-required": true,
          error: _ctx.errors.LastName
        }, null, 8, ["modelValue", "error"])
      ]),
      _createVNode(_component_TextInput, {
        type: "text",
        name: "mixed",
        label: "Local # ",
        placeholder: "Local #",
        max: 20,
        modelValue: _ctx.local.OrgName,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.local.OrgName) = $event)),
        "is-required": true,
        error: _ctx.errors.OrgName
      }, null, 8, ["modelValue", "error"]),
      _createElementVNode("div", null, [
        _createVNode(_component_TextInput, {
          type: "password",
          label: "Create Password",
          placeholder: "Enter Password",
          max: 50,
          modelValue: _ctx.local.Password,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.local.Password) = $event)),
          "is-required": true,
          error: _ctx.errors.Password
        }, null, 8, ["modelValue", "error"]),
        _hoisted_4
      ]),
      _createVNode(_component_TextInput, {
        type: "password",
        label: "Confirm Password",
        placeholder: "Enter Password",
        max: 50,
        modelValue: _ctx.local.Password_confirmation,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.local.Password_confirmation) = $event)),
        "is-required": true,
        error: _ctx.errors.Password_confirmation
      }, null, 8, ["modelValue", "error"]),
      _hoisted_5,
      _createVNode(_component_SelectComponent, {
        label: "Security Question",
        error: _ctx.errors['SecurityQuestions.0.Question'],
        selectedOption: _ctx.local.SecurityQuestion1.Question,
        "onUpdate:selectedOption": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.local.SecurityQuestion1.Question) = $event)),
        options: _ctx.availableQuestionsForSelect(1).value,
        "is-required": true,
        onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleQuestionSelect(1)))
      }, null, 8, ["error", "selectedOption", "options"]),
      _createVNode(_component_TextInput, {
        type: "text",
        name: "mixed",
        label: "Answer",
        placeholder: "Enter Answer",
        max: 50,
        modelValue: _ctx.local.SecurityQuestion1.Answer,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.local.SecurityQuestion1.Answer) = $event)),
        "is-required": true,
        error: _ctx.errors['SecurityQuestions.0.Answer']
      }, null, 8, ["modelValue", "error"]),
      _createVNode(_component_SelectComponent, {
        label: "Security Question 2",
        error: _ctx.errors['SecurityQuestions.1.Question'],
        selectedOption: _ctx.local.SecurityQuestion2.Question,
        "onUpdate:selectedOption": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.local.SecurityQuestion2.Question) = $event)),
        options: _ctx.availableQuestionsForSelect(2).value,
        "is-required": true,
        onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleQuestionSelect(2)))
      }, null, 8, ["error", "selectedOption", "options"]),
      _createVNode(_component_TextInput, {
        type: "text",
        name: "mixed",
        label: "Answer",
        placeholder: "Enter Answer 2",
        max: 50,
        modelValue: _ctx.local.SecurityQuestion2.Answer,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.local.SecurityQuestion2.Answer) = $event)),
        "is-required": true,
        error: _ctx.errors['SecurityQuestions.1.Answer']
      }, null, 8, ["modelValue", "error"]),
      _createVNode(_component_SelectComponent, {
        label: "Security Question 3",
        error: _ctx.errors['SecurityQuestions.2.Question'],
        selectedOption: _ctx.local.SecurityQuestion3.Question,
        "onUpdate:selectedOption": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.local.SecurityQuestion3.Question) = $event)),
        options: _ctx.availableQuestionsForSelect(3).value,
        "is-required": true,
        onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleQuestionSelect(3)))
      }, null, 8, ["error", "selectedOption", "options"]),
      _createVNode(_component_TextInput, {
        type: "text",
        name: "mixed",
        label: "Answer",
        placeholder: "Enter Answer 3",
        max: 50,
        modelValue: _ctx.local.SecurityQuestion3.Answer,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.local.SecurityQuestion3.Answer) = $event)),
        "is-required": true,
        error: _ctx.errors['SecurityQuestions.2.Answer']
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_ReCaptcha, {
        recaptchaError: _ctx.recaptchaError,
        loadingRecaptcha: _ctx.loadingRecaptcha,
        token: _ctx.token,
        "onUpdate:recaptchaError": _cache[17] || (_cache[17] = ($event: any) => (_ctx.recaptchaError = $event)),
        "onUpdate:loadingRecaptcha": _cache[18] || (_cache[18] = ($event: any) => (_ctx.loadingRecaptcha = $event)),
        "onUpdate:token": _cache[19] || (_cache[19] = ($event: any) => (_ctx.token = $event))
      }, null, 8, ["recaptchaError", "loadingRecaptcha", "token"]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary w-100 lh-1 border-radius-8",
          onClick: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)), ["prevent"])),
          disabled: _ctx.loadingSubmit
        }, " Discard ", 8, _hoisted_8),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary plan-modal w-100 lh-1 border-radius-8",
          onClick: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRegister && _ctx.handleRegister(...args)), ["prevent"])),
          onKeypress: _cache[22] || (_cache[22] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleRegister && _ctx.handleRegister(...args)), ["enter"])),
          disabled: _ctx.loadingSubmit
        }, [
          _createTextVNode(" Submit "),
          (_ctx.loadingSubmit)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
            : _createCommentVNode("", true)
        ], 40, _hoisted_9)
      ])
    ])
  ], 64))
}